module.exports = __webpack_public_path__ + "img/italy-infectious-diseases-male.1e9e5153.png";